// this is an autogenerated file from App/Account/Search/Content/Profiles/Content/Profile/InApp/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Search_Content_Profiles_Content_Profile_InApp($person_id: numeric!) {
  thread: comms_threads_in_app_create(person_id: $person_id) {
    id
  }
}

`